module.exports = __webpack_public_path__ + "img/p9-1.38483be1.png";